<template>
	<div class="forget">
		<el-dialog title="找回登录密码" width="600px" :visible.sync="fshow" :before-close="onqx">
			<div class="form" v-if="fshow">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
					<el-form-item label="手机号" prop="mobile">
						<el-input v-model="ruleForm.mobile" placeholder="请输入手机号"></el-input>
					</el-form-item>

					<el-form-item label="验证码" prop="code">
						<el-input v-model="ruleForm.code" placeholder="请输入验证码"></el-input>
						<span class="verify-btn" @click="handleGetVerifyCode">
							{{ verifyCodeText }}
						</span>
					</el-form-item>

					<el-form-item label="新登录密码" prop="password">
						<el-input v-model="ruleForm.password" show-password placeholder="请输入新登录密码" autocomplete="new-password"></el-input>
					</el-form-item>

					<el-form-item label="确认登录密码" prop="confirm_password">
						<el-input v-model="ruleForm.confirm_password" show-password placeholder="请确认登录密码" autocomplete="new-password"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onqx()">取消</el-button>
				<el-button type="primary" @click="onsub()">确定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog title="验证码" :visible.sync="yzmshow" width="440px">
			<el-form :model="yzmform" ref="yzmform" :rules="yzmRules">
				<el-form-item class="yzmitem" prop="yzm">
					<el-input v-model="yzmform.yzm" placeholder="请输入验证码" class="yzminput"></el-input>
					<img :src="imgsrc" class="imgsrc" @click="generateRandomLetters()">
				</el-form-item>
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="onyzmgb()" size="small">取消</el-button>
				<el-button type="primary" @click="onyzmsub()" size="small">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'Forget',
		data() {
			var validateConfirmPassword = (rule, value, callback) => {
				if (value == '') {
					callback(new Error('请再次输入密码'))
				} else if (value != this.ruleForm.password) {
					callback(new Error('两次输入密码不一致'))
				} else {
					callback()
				}
			}

			var validatePhone = (rule, value, callback) => {
				const phoneReg = /^1[3-9]\d{9}$/
				if (value == '') {
					callback(new Error('请输入手机号'))
				} else if (!phoneReg.test(value)) {
					callback(new Error('请输入正确的手机号'))
				} else {
					callback()
				}
			}
			return {
				ruleForm: {
					mobile: "",
					code: "",
					password: "",
					confirm_password: ""
				},

				rules: {
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '密码长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],
					confirm_password: [{
						required: true,
						validator: validateConfirmPassword,
						trigger: 'blur'
					}],
					mobile: [{
						required: true,
						validator: validatePhone,
						trigger: 'blur'
					}],
					code: [{
							required: true,
							message: '请输入验证码',
							trigger: 'blur'
						},
						{
							len: 4,
							message: '验证码为4位数字',
							trigger: 'blur'
						}
					],
				},
				
				verifyCodeDisabled: false,
				verifyCodeText: '获取验证码',
				
				yzmshow: false,
				randomLetters: "",
				imgsrc: "",
				yzmform: {
					yzm: "",
				},
				
				yzmRules: {
					yzm: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}]
				},
			}
		},
		
		props: {
			fshow: { //用于回显
				type: Boolean,
				default: false
			},
		},

		methods: {
			handleGetVerifyCode() {
				if (this.verifyCodeDisabled) {
					return;
				}
			
				if (!this.ruleForm.mobile) {
					this.$message.warning('请先输入手机号');
					return
				}
			
				// 验证手机号格式
				const phoneReg = /^1[3-9]\d{9}$/
				if (!phoneReg.test(this.ruleForm.mobile)) {
					this.$message.warning('请输入正确的手机号')
					return
				}
				this.generateRandomLetters();
				this.yzmshow = true;
			},
			
			generateRandomLetters() {
				let result = '';
				for (let i = 0; i < 4; i++) {
					const randomCharCode = Math.floor(Math.random() * 26) + 65; // 生成65到90之间的随机数，对应大写字母A-Z
					result += String.fromCharCode(randomCharCode);
				}
				this.randomLetters = result + new Date().getTime();
				this.imgsrc = "http://api.zhidayd.com/adapipublic/captcha?uniq=" + this.randomLetters;
			},
			
			onyzmsub() {
				this.$refs['yzmform'].validate((valid) => {
					if (valid) {
						var params = {
							mobile: this.ruleForm.mobile,
							uniq: this.randomLetters,
							captcha: this.yzmform.yzm
						};
						this.$axios.post('api/sms/send', params).then(res => {
							if (res.data.code == 0) {
								this.$message.success('验证码已发送');
								this.verifyCodeDisabled = true;
								this.countdown = 60;
								this.onyzmgb();
								const timer1 = setInterval(() => {
									this.countdown--
									this.verifyCodeText = `${this.countdown}秒后重试`
									if (this.countdown <= 0) {
										clearInterval(timer1)
										this.verifyCodeDisabled = false
										this.verifyCodeText = '获取验证码'
									}
								}, 1000);
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},
			
			onyzmgb() {
				this.yzmform.yzm = "";
				this.yzmshow = false;
			},
			
			
			
			onqx() {
				this.$emit('update:fshow', false);
				this.ruleForm = {
					mobile: "",
					code: "",
					password: "",
					confirm_password: ""
				};
			},

			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$axios.post('api/user/user_forget_password', this.ruleForm).then(res => {
							if (res.data.code == 0) {
								this.$message.success('密码修改成功');
								this.onqx();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.verify-btn {
		position: absolute;
		right: 14px;
		font-size: 14px;
		color: #2D93FF;
		cursor: pointer;
	}
	
	.yzmitem {
		position: relative;
	}
	
	.imgsrc {
		width: 120px;
		height: 36px;
		cursor: pointer;
		position: absolute;
		right: 2px;
		top: 2px;
	}
</style>



// WEBPACK FOOTER //
// src/common/forget.vue